// ---- Global variables ---
var upselledItems = [];
var curOffer = null;
var noOffer = true;
var upsellSliderInitalized = false;
var oldVariant = null;
var offerProductsCache = {};

// --- Events ---

// Get the modal (Background)
var modal = document.getElementById("ngb-upsell-modal");

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target == modal) {
    closeModal();
  }
}

// Get the button that opens the modal
var openButton = document.getElementById("AddToCart_upsell");

// When the user clicks the button, open the modal
function setOpenButtonToOffer() {
  openButton.onclick = function() {
    loadVendorJs();
    
    //reset AddToCart Buttons from upsell modal
    upselledItems = [];
    $(".ngb-upsell-modal-addToCart").html("In den Warenkorb legen");

    if (noOffer) {
     $( "#AddToCart .button").trigger( "click" );
    }
    else {
      modal.style.display = "block";
      $("#ngb-upsell-modal-slider").slick("refresh")

      $.post( "https://webservice.naturalgoodsberlin.de/ngb-upsell-app/upsell/offers/" + curOffer.id + "/stats/opened/add/1", function( data ) {
      
      });

      var intervalId = setTimeout(function() {
        $("#ngb-upsell-modal-slider").slick("refresh");
      
        }, 700);

      setTimeout(function() {
        clearInterval(intervalId);
       
      }, 500)
    }
  }
}



function closeModal() {
  
//document.getElementById('AddToCart').click(); 
$( "#AddToCart .button").trigger( "click" );
  modal.style.display = "none";
}

// When the user clicks on <span> (x), close the modal
var closeButton = document.getElementById("ngb-upsell-close");

closeButton.onclick = function() {
 
  closeModal();
}

// Ok Button from upsell modal, adds orginial item to cart and opens sidebar cart(by executing the code of the original "AddToCard" Button)
var okButton = document.getElementsByClassName("ngb-upsell-modal-ok")[0];

okButton.onclick = function() {
  closeModal();
}

function addToCartOnClick(senderButton, variantId, productHandle) {

  if (upselledItems.indexOf(variantId) < 0) {

    addItemToCart(variantId, 1, function(success) {

      if (success) {
        senderButton.innerHTML = '<i class="fa fa-check" aria-hidden="true"></i>';

        var product = offerProductsCache[productHandle], selectedVariant;

        product.variants.forEach(variant => {
          if (variant.id === variantId) {
            selectedVariant = variant;
            return;
          }
        })
      
        $.post( "https://webservice.naturalgoodsberlin.de/ngb-upsell-app/upsell/offers/" + curOffer.id + "/stats/inCart/add/1", function( data ) {
        
        });
      
        if (selectedVariant) {
          var price = selectedVariant.price ;
          $.post( "https://webservice.naturalgoodsberlin.de/ngb-upsell-app/upsell/offers/" + curOffer.id + "/stats/priceSum/add/" + price, function( data ) {
         
          });
        }

        upselledItems.push(variantId);
      }
      else {
        alert("Leider ist ein beim hinzufügen in den Warenkorb ein Fehler aufgetreten.");
      }
    });
  }

}

//changed variant for a offer product in modal
function variantInDropDownClicked(variantId, productHandle) {
 

  //get variant informations
  var product = offerProductsCache[productHandle], selectedVariant;

  product.variants.forEach(variant => {
    if (variant.id === variantId) {
      selectedVariant = variant;
      return;
    }
  })

  if (selectedVariant) {

    var offerImageSrc = null;

    if (selectedVariant.featured_image) {
      offerImageSrc = selectedVariant.featured_image.src;
    }
  
    if (!offerImageSrc) {
      offerImageSrc = product.featured_image;
    }

    var price = Shopify.formatMoney(selectedVariant.price, moneyFormatNgb);

    $(".ngb-upsell-modal-offer-product-image[data-product-handle=\"" + productHandle + "\"]").attr("src", offerImageSrc);
    $(".ngb-upsell-modal-offer-product-price[data-product-handle=\"" + productHandle + "\"]").text(price);
    $(".ngb-upsell-modal-addToCart[data-product-handle=\"" + productHandle + "\"]").attr("onClick", "addToCartOnClick(this, " + variantId + ", \"" + productHandle + "\")");
    $(".ngb-upsell-modal-addToCart[data-product-handle=\"" + productHandle + "\"]").html("In den Warenkorb legen");
  }
}

// Create a new html element with a upsell offer
function addProductOffer(product, offerProductInfos) {  
 
  var variantRows = ""; //rows in the dropdown to choose the variant of the offered product

  product.variants.forEach(variant => {
    if (variant.available) {
      variantRows = variantRows.concat('<p class="ngb-upsell-dropdown-row" onclick="variantInDropDownClicked(' + variant.id + ", '" + product.handle + "'" + ')">' + variant.title + '</p>');
    }
  });

  //get standardVariant from offerProduct
  var standardVariantId = offerProductInfos.standardVariant, selectedVariant;
 

  if (offerProductInfos.standardVariant) {
    for (var i = 0; i < product.variants.length; i++) {
      var variant = product.variants[i];

      if (variant.id === standardVariantId) {
        selectedVariant = variant;
        break;
      }
    }
  }

  //take first variant of product, if no standardVariant is set
  if (!selectedVariant) {
    selectedVariant = product.variants[0];
  }

  //save information to offer in map, for later access when selected variant in modal changes
  offerProductsCache[offerProductInfos.handle] = product;

  //get image for offer
  var offerImageSrc = null;

  if (selectedVariant.featured_image) {
    offerImageSrc = selectedVariant.featured_image.src;
  }

  if (!offerImageSrc) {
    offerImageSrc = product.featured_image;
  }

  //set price
  var price = Shopify.formatMoney(selectedVariant.price, moneyFormatNgb);



  var main = 
      '<div class="ngb-upsell-modal-offer-product">'
    +   '<center>'
    +     '<div class="ngb-upsell-offer-product-title"><h4> ' + product.title + '</h4></div>'
    +     '<div class="ngb-upsell-dropdown">'
    +       '<h5 class="ngb-upsell-dropdown-symbol"><span class="ngb-upsell-dropdown-title ">' + "Variante auswählen" /*selectedVariant.title*/ + '</span></h5>'
    +       '<div class="ngb-upsell-dropdown-content">'
    +         variantRows
    +       '</div>'
    +     '</div>'
    +     '<img class="ngb-upsell-modal-offer-product-image" data-product-handle="' + offerProductInfos.handle + '" src="' + offerImageSrc + '"/>'
    +     '<h5 class="ngb-upsell-modal-offer-product-price"  data-product-handle="' + offerProductInfos.handle + '">' + price + '</h5>'
    +     '<button type="button" class="ngb-upsell-modal-addToCart" data-product-handle="' + offerProductInfos.handle + '" onClick="addToCartOnClick(this, ' + selectedVariant.id + ", '" + offerProductInfos.handle + "'" + ')">In den Warenkorb legen</button>'
    +   '</center>'
    + '</div>';

  $("#ngb-upsell-modal-slider").append(main);

}

//init the modal
function buildNgbUpsellModal(variant) {
  if (!$.fn.slick) {
    loadVendorJs();
  }
  
  if (variant == oldVariant) {
    return;
  }

  oldVariant = variant;

  //get offer from backend
  getOffer(variant, (data, err) => {
 
    curOffer = data;

    upselledItems = [];

    //TODO: only hijack original addToCart-Button, if the call to backend with offer data for variant was successfull
    
    unslickUpsellSlider()

    noOffer = !curOffer || curOffer.offerProducts.length === 0 || !curOffer.active; //no offer available for that variant



    $("#ngb-upsell-modal-slider").empty(); //delete old offerProducts

 
    initUpsellSlick();
    setOpenButtonToOffer();

    if (!noOffer) {

      $("#ngb-upsell-modal-header-title").text(curOffer.title);
      $("#ngb-upsell-modal-header-subtitle").text(curOffer.subtitle);

    

      curOffer.offerProducts.forEach(product => {
        getProductInfos(product.handle, (productInfos) => {
          addProductOffer(productInfos, product);
        });
      });
    }
  });
}

function initUpsellSlick() {
  loadVendorJs();
  

  if (!upsellSliderInitalized && curOffer) {

    var numOfOfferProducts = curOffer.offerProducts.length;

    //noOffer = (numOfOfferProducts === 0); //show no offer, if the offerProducts are empty

    //create slick slider for upsell offer products
    $("#ngb-upsell-modal-slider").slick({
      dots: false, 
      lazyLoad: 'progressive', 
      slidesToShow: (numOfOfferProducts < 3) ? numOfOfferProducts : 3, 
      slidesToScroll: 1,
      responsive: [{
          breakpoint: 900,
          settings: {
            slidesToShow: (numOfOfferProducts < 1) ? numOfOfferProducts : 1
          }
        },{
          breakpoint: 1450,
          settings: {
            slidesToShow: (numOfOfferProducts < 2) ? numOfOfferProducts : 2
          }
        }
      ]
    });
  }

  upsellSliderInitalized = true;
}

function unslickUpsellSlider() {

  if (upsellSliderInitalized) {

    $("#ngb-upsell-modal-slider").slick("unslick");
  }

  upsellSliderInitalized = false;
}

// --- backend calls ---

//get offerProducts for current variant
function getOffer(variant, callback) {

  $.get( "https://webservice.naturalgoodsberlin.de/ngb-upsell-app/upsell/offers?forVariant=" + variant.id, function( data ) {
 
    
    callback(data, null);
  })
  .fail(function() {

    callback(null, "error");
  });
}

//return variant details
function getVariantInfos(productHandle, variantId, callback) {
  Shopify.getProduct(productHandle, (product) => {
    if (!product) {
      return null;
    }

    //search for variant in product
    product.variants.forEach((variant) => {
      if (variant.id === variantId) {
        callback(variant);
      }
    });
  });
}

//return variant details
function getProductInfos(productHandle, callback) {
      var uhandle = window.location.pathname;
      var u_handle = uhandle.split("products/");
      var f_handle = u_handle[1];

  Shopify.getProduct(productHandle, (product) => {

      //console.log(product);
    if (!product) {
      return null;
    }

    callback(product);
  });
}

//POST to Ajax Shopify API(Cart)
function addItemToCart(variantId, quantity, callback) {
  jQuery.post('/cart/add.js', {
    items: [
      {
        quantity: quantity,
        id: variantId
      }
    ]
  }).done(function(msg){ callback(true) })
  .fail(function(xhr, status, error) {
    callback(xhr.status === 200); //execute callback with success-parameter set to true, if cart-action returns with status code 200
  });
}